export default "__VITE_ASSET__iTaWgxFo__"